"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicClientType = void 0;
var SeismicClientType;
(function (SeismicClientType) {
    SeismicClientType["SALESFORCE"] = "SalesforceRequester";
    SeismicClientType["DYNAMICS"] = "DynamicsRequester";
    SeismicClientType["ORACLE"] = "OracleRequester";
    SeismicClientType["HTML"] = "HtmlRequester";
    SeismicClientType["LIVESHARE"] = "LiveShareCenter";
    SeismicClientType["SHAREPOINT"] = "SharePointRequester";
    SeismicClientType["DOCCENTER"] = "DocCenter";
})(SeismicClientType = exports.SeismicClientType || (exports.SeismicClientType = {}));
//# sourceMappingURL=SeismicClientType.js.map